import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'eventStatus'
})
export class EventStatusPipe implements PipeTransform {

  transform(eventStatus: number): string {

    switch (eventStatus) {
      case 1:
      return "Alarm triggered"

      case 2:
      return "Alarm cleared"

      case 3:
      return "Warning"

      default:
        break;
    }

  }

}
